export type Locale = "zh-CN" | "zh-TW" | "en" | "ja" | "ko" | "es" | "fr" | "de" | "pt-BR" | "ru" | "ar";

export const DEFAULT_LOCALE: Locale = "zh-CN";
export const LOCALE_COOKIE = "30s.to.locale";
export const SUPPORTED_LOCALES: readonly Locale[] = ["zh-CN", "zh-TW", "en", "ja", "ko", "es", "fr", "de", "pt-BR", "ru", "ar"];

const LOCALE_LABELS: Record<Locale, string> = {
  "zh-CN": "中文",
  "zh-TW": "繁體中文",
  en: "English",
  ja: "日本語",
  ko: "한국어",
  es: "Español",
  fr: "Français",
  de: "Deutsch",
  "pt-BR": "Português (Brasil)",
  ru: "Русский",
  ar: "العربية"
};

export function normalizeLocale(value?: string | null): Locale | null {
  if (!value) return null;
  const normalized = value.trim().toLowerCase().replaceAll("_", "-");
  if (
    ["zh-tw", "zh-hk", "zh-mo"].some((tag) => normalized === tag || normalized.startsWith(`${tag}-`))
    || normalized === "zh-hant"
    || normalized.startsWith("zh-hant-")
  ) return "zh-TW";
  if (normalized === "zh" || normalized.startsWith("zh-")) return "zh-CN";
  if (normalized === "en" || normalized.startsWith("en-")) return "en";
  if (normalized === "ja" || normalized.startsWith("ja-")) return "ja";
  if (normalized === "ko" || normalized.startsWith("ko-")) return "ko";
  if (normalized === "es" || normalized.startsWith("es-")) return "es";
  if (normalized === "fr" || normalized.startsWith("fr-")) return "fr";
  if (normalized === "de" || normalized.startsWith("de-")) return "de";
  if (normalized === "pt" || normalized.startsWith("pt-")) return "pt-BR";
  if (normalized === "ru" || normalized.startsWith("ru-")) return "ru";
  if (normalized === "ar" || normalized.startsWith("ar-")) return "ar";
  return null;
}

export function getLocaleDirection(locale: Locale): "ltr" | "rtl" {
  return locale === "ar" ? "rtl" : "ltr";
}

export function getLocaleLabel(locale: Locale): string {
  return LOCALE_LABELS[locale];
}
